export const ChatBotMessages = {
  copy: '复制',
  copied: '复制成功',
  copyCode: '复制代码',
  copyFailed: '复制失败',
}
